import React, { useContext } from "react";
import { ConfirmDialog } from "sprint-common-web";

import { useFileRecordApi } from "../../../../../common/api/master-api/file-records/useFileRecordApi";
import { FileRecordStatus } from "../../../../../common/types/FileRecordStatus";
import { FileRecordListingContext } from "../../context/FileRecordListingContext";

interface ChangeFileRecordToQcListingDialogProps {
    onClose(): void;
    isOpen: boolean;
    itemId: string;
}

export const ChangeFileRecordToQcListingDialog: React.VFC<ChangeFileRecordToQcListingDialogProps> = ({
    itemId,
    isOpen,
    onClose
}: ChangeFileRecordToQcListingDialogProps) => {
    const { changeFileRecordToQc } = useFileRecordApi();

    const { updateFileRecordStatus } = useContext(FileRecordListingContext);

    const handleConfirmation = async () => {
        await changeFileRecordToQc({ fileRecordId: itemId });

        updateFileRecordStatus(itemId, FileRecordStatus.Qc);

        onClose();
    };

    return (
        <ConfirmDialog
            title="Change status to Qc"
            text="Are you sure you want to update given file record status to Qc?"
            hidden={!isOpen}
            confirm={{ onClick: handleConfirmation }}
            cancel={{ onClick: onClose }}
        />
    );
};
